import { Provider } from 'react-redux';

import { BasicContent } from './BasicContent';
import RichText from './RichText';
import { CalculatorCellulose } from '../../ProPink/CalculatorCellulose';
import { store } from '../../Store';
import Container from '../oc-container';

const CMSCelluloseCalculator = ({ ...content }) => (
  <>
    <BasicContent {...content.copy} />
    <Provider store={store}>
      <Container maxWidth="1170">
        <CalculatorCellulose />
      </Container>
    </Provider>
    <RichText content={content.footnotes} />
  </>
);

export default CMSCelluloseCalculator;
